import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchNotesList(_, { notableType, notableId }) {
      return axiosIns.get(`/notes/${notableType}/${notableId}`)
    },
    addNote(_, {
      notableType, notableId, note, addedBy, category,
    }) {
      return axiosIns.post(`/notes/${notableType}/${notableId}`, {
        note,
        addedBy,
        category,
      })
    },
    editNote(_, {
      notableType, notableId, note, noteId, category, addedBy,
    }) {
      return axiosIns.patch(`/notes/${noteId}/${notableType}/${notableId}`, { note, category, addedBy })
    },

  },
}
